import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useState } from 'react';
import { Button, ButtonColors, ButtonVariants } from '../../Button';
import DiscardNoteModal from '../modals/DiscardNoteModal';
import styles from '../TextEditor.module.css';
import AutosaveIndicator from './AutoSaveIndicator';
import RevertChangesButton from './RevertChangesButton';

type Props = {
  disabled?: boolean;
  onSubmit: () => Promise<void>;
  onRevert?: () => void;
  initialValue?: string;
  isDirty?: boolean;
  lastSavedAt: Date | null;
  isLoading?: boolean;
  buttonFullWidth: boolean;
};

export default function TextEditorFooter({
  disabled,
  onSubmit,
  onRevert,
  initialValue,
  isDirty,
  lastSavedAt,
  isLoading,
  buttonFullWidth,
}: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editor] = useLexicalComposerContext();

  function handleCloseModal() {
    setIsModalOpen(false);
  }

  function handleOpenModal() {
    setIsModalOpen(true);
  }

  function handleRevert() {
    if (!initialValue) return;

    const editorState = editor.parseEditorState(initialValue);

    editor.setEditorState(editorState);

    onRevert?.();
    handleCloseModal();
  }

  return (
    <>
      <div className={styles.footer}>
        <div className={styles.footerTop}>
          <div className={styles.revertContainer}>
            {initialValue && lastSavedAt && isDirty ? (
              <RevertChangesButton
                onClick={handleOpenModal}
                disabled={isLoading}
              />
            ) : null}
          </div>
          <div className={styles.autosaveContainer}>
            <AutosaveIndicator lastSavedAt={lastSavedAt} />
          </div>
        </div>
        <div className={styles.footerBottom}>
          <Button
            variant={ButtonVariants.SOLID}
            color={ButtonColors.PURPLE}
            width={buttonFullWidth ? 'full' : undefined}
            disabled={disabled}
            onClick={onSubmit}
          >
            Publish
          </Button>
        </div>
      </div>
      <DiscardNoteModal
        isOpen={isModalOpen && !!initialValue}
        onClose={handleCloseModal}
        onCancel={handleCloseModal}
        onDiscard={handleRevert}
      />
    </>
  );
}
